import React, { useEffect, useState } from "react";
import Joyride, { Step, CallBackProps } from "react-joyride";
import { useTranslation } from "@me8eon/translation";
import "./TourStart.scss";
interface TourGuideProps {
    run: boolean;
    onTourEnd: () => void;
    steps: Step[];
    allowSidebarScroll?: boolean;
}
const TileTour: React.FC<TourGuideProps> = ({ run, onTourEnd, steps, allowSidebarScroll = false }) => {
    const t = useTranslation();
    const [total, setTotal] = useState<number>(0);
    const [step, setStep] = useState<number>(0);

    useEffect(() => {
        if (!run || !allowSidebarScroll) return;

        const handleWheel = (event: WheelEvent) => {
            if (!(event.target instanceof Element) || !event.target.closest(".react-joyride__overlay")) return;
            const sidebar = document.querySelector<HTMLElement>(".sidebar-layout-new .sidebar-body");
            if (!sidebar) return;
            const rect = sidebar.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) return;

            const scale = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? sidebar.clientHeight : 1;
            sidebar.scrollTop += event.deltaY * scale;
            event.preventDefault();
        };

        document.addEventListener("wheel", handleWheel, { passive: false });
        return () => document.removeEventListener("wheel", handleWheel);
    }, [run, allowSidebarScroll]);

    const handleJoyrideCallback = (data: CallBackProps) => {
        const { status, size, index, action } = data;
        if (action === "update") {
            setTotal(size);
            setStep(index + 1);
        }
        const finishedStatuses = ["finished", "skipped"];
        if (finishedStatuses.includes(status)) {
            onTourEnd();
        }
    };

    return (
        <div data-testid={run ? "tileTour" : ""}>
            <Joyride
                steps={steps}
                run={run}
                continuous={true}
                scrollToFirstStep={true}
                scrollOffset={80}
                showProgress={true}
                showSkipButton={true}
                callback={handleJoyrideCallback}
                data-testid="tileTour"
                disableOverlayClose={true}
                hideCloseButton={true}
                locale={{
                    back: t("tourData.userActions.back"),
                    close: t("tourData.userActions.close"),
                    last: t("tourData.userActions.last"),
                    nextLabelWithProgress: `${t("tourData.userActions.next")} (${t("tourData.userActions.step")} ${step} ${t("tourData.userActions.of")} ${total})`,
                    open: t("tourData.userActions.open"),
                    skip: t("tourData.userActions.skip"),
                }}
                styles={{
                    options: {
                        arrowColor: "#fff",
                        backgroundColor: "#fff",
                        overlayColor: "rgba(0, 0, 0, 0.4)",
                        primaryColor: "#1ea2b1",
                        textColor: "#262626",
                        width: 300,
                        zIndex: 1005,
                    },
                }}
            />
        </div>
    );
};

export default TileTour;
